import { DefaultTheme } from 'styled-components';
import { getToken, Size } from '@optimus-web/common';

export const getEndStrokeDashoffsetValue = (size: Exclude<Size, 'extraLarge'>) => {
    switch (size) {
        case 'small':
            return '-55';
        case 'medium':
            return '-90';
        case 'large':
            return '-125';
    }
};

export const getSizeProperties = (size: Exclude<Size, 'extraLarge'>, theme: DefaultTheme) => {
    switch (size) {
        case 'small':
            return {
                dimension: getToken('sizing300')({ theme }),
                radius: 9,
                strokeWidth: 2,
            };
        case 'medium':
            return {
                dimension: getToken('sizing500')({ theme }),
                radius: 15,
                strokeWidth: 4,
            };
        case 'large':
            return {
                dimension: getToken('sizing700')({ theme }),
                radius: 21,
                strokeWidth: 4,
            };
    }
};
